import css from 'styled-jsx/css';

export default css`
  .AmpSideBySide {
    margin: 1rem 0;
    clear: both;
    overflow: hidden;
  }
  .AmpSideBySide :global(.AmpImg) {
    margin-bottom: 1rem;
  }
  .AmpSideBySide--small :global(.AmpImg) {
    margin: 0 auto 2rem;
    width: 200px;
  }
  .AmpSideBySide--small :global(amp-img) {
    border-radius: 50%;
    overflow: hidden;
  }
  @media (min-width: 768px) {
    .AmpSideBySide--small :global(.AmpImg) {
      margin: 0 1rem 1rem 0;
      float: left;
      width: 200px;
    }
    .AmpSideBySide--large :global(.AmpImg) {
      margin: 0 1rem 1rem 0;
      float: left;
      width: 334px;
    }
    .AmpSideBySide--small :global(.AmpImg) {
      width: 140px;
    }
  }
`;
